import { useEffect, useState } from "react";
import getUrl from "../../utility/getUrl";
import { AuthenticationInfoType } from "../../utility/types";
import Status from "../Status";

type EnterOrganizationIdProps = {
  onFinish: (organizationId: string) => void;
  auth: AuthenticationInfoType;
};
const EnterOrganizationId = ({ auth, onFinish }: EnterOrganizationIdProps) => {
  const [organizationId, setOrganizationId] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    const getOrganizationName = async () => {
      try {
        setStatus("");
        const url = getUrl("organizationNameById", organizationId);
        const options = {
          headers: new Headers({
            Authorization: `Bearer ${auth.accessToken}`,
          }),
        };
        const response = await fetch(url, options);

        if (!response.ok) {
          let error = "Organization not found";
          if (response.status === 401) {
            error = "Sorry, you have no access to this service";
          }
          setStatus(error);
          setOrganizationName("");
          return;
        }

        const organizationName = await response.text();
        setOrganizationName(organizationName);
      } catch (err) {
        console.error(err);
      }
    };

    if (organizationId) {
      getOrganizationName();
    }
  }, [organizationId, auth]);

  const onFocus = (ev: any) => {
    if (ev.target) {
      ev.target.select();
    }
  };

  const onChange = (ev: any) => {
    const orgId = ev.target.value;
    setOrganizationId(orgId);
  };

  const onClickButton = () => {
    onFinish(organizationId);
  };

  return (
    <div className="enter-organizationid">
      <label>
        <div className="label">Organization Id:</div>
        <input
          placeholder="enter organization id"
          className="input-text"
          type="text"
          onFocus={onFocus}
          value={organizationId}
          onChange={onChange}
        />
      </label>

      <label>
        <div className="label">Organization Name:</div>
        <div className="output-text"> {organizationName}</div>
      </label>

      <Status msg={status}></Status>

      <button className="button" disabled={!organizationName} onClick={onClickButton}>
        OK
      </button>
    </div>
  );
};

export default EnterOrganizationId;
